import { render, staticRenderFns } from "./OneGroup.vue?vue&type=template&id=6cbcfcda&scoped=true"
import script from "./OneGroup.vue?vue&type=script&lang=js"
export * from "./OneGroup.vue?vue&type=script&lang=js"
import style0 from "./OneGroup.vue?vue&type=style&index=0&id=6cbcfcda&prod&lang=scss&scoped=true"
import style1 from "./OneGroup.vue?vue&type=style&index=1&id=6cbcfcda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbcfcda",
  null
  
)

export default component.exports